
import { db, serverTimestamp } from "../../firebaseClient";
import type { Lawyer } from "../types/legalOps";

const COLLECTION = "legal_lawyers";

export async function createLawyer(data: Omit<Lawyer, "id">): Promise<string> {
  const docData = {
    ...data,
    isDeleted: false,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
  const docRef = await db.collection(COLLECTION).add(docData);
  return docRef.id;
}

export async function updateLawyer(id: string, data: Partial<Lawyer>): Promise<void> {
  // Use set with merge to ensure no errors if doc doesn't exist (robustness)
  await db.collection(COLLECTION).doc(id).set({
    ...data,
    updatedAt: serverTimestamp(),
  }, { merge: true });
}

/**
 * Soft Delete Lawyer
 * Updates status to 'deleted' and isDeleted flag to true.
 * Does not remove the document to preserve history.
 */
export async function softDeleteLawyer(id: string): Promise<void> {
  // Use set with merge: true to prevent "No document to update" error
  await db.collection(COLLECTION).doc(id).set({
    isDeleted: true,
    status: "deleted",
    updatedAt: serverTimestamp()
  }, { merge: true });
}
